import {Component} from '@angular/core';
import {AbstractFormDirective, FormControlsConfig} from '../components/abstract-form-directive';
import {ReactiveFormsModule} from '@angular/forms';
import {ProjectStepSaveButtonComponent} from '../../../../../../../shared/project-step-save-button/project-step-save-button.component';
import {TranslocoPipe} from '@jsverse/transloco';
import {toSignal} from '@angular/core/rxjs-interop';
import {TranslateDirectusPipe} from '@frontend/transloco';
import {MultiSelectionLabelComponent} from '../../../../../../../shared/components/inputs/form-field/form-field-multiselect/multi-selection-label/multi-selection-label.component';
import {ContractParametersResponse} from '@frontend/shared';
import {FormFieldMultiselectComponent} from '../../../../../../../shared/components/inputs/form-field/form-field-multiselect/form-field-multiselect.component';

@Component({
  selector: 'app-project-scope',
  imports: [
    ReactiveFormsModule,
    ProjectStepSaveButtonComponent,
    TranslocoPipe,
    MultiSelectionLabelComponent,
    FormFieldMultiselectComponent,
  ],
  templateUrl: './project-scope.component.html',
  providers: [TranslateDirectusPipe],
})
export class ProjectScopeComponent extends AbstractFormDirective<ContractParametersResponse> {
  private static readonly FORM_CONTROLS: FormControlsConfig<ContractParametersResponse> = {
    languages: [[]],
    countries: [[]],
    functions: [[]],
  };

  protected readonly languageOptions = toSignal(this.directusService.loadLanguageOptions(), {
    initialValue: [],
  });

  protected readonly countryOptions = toSignal(this.directusService.loadCountryOptions(), {
    initialValue: [],
  });

  protected readonly functionOptions = toSignal(this.directusService.loadFunctionOptions(), {
    initialValue: [],
  });

  constructor() {
    super(ProjectScopeComponent.FORM_CONTROLS);
  }
}
